import { render, staticRenderFns } from "./AltUsers.vue?vue&type=template&id=3097a313&scoped=true&"
import script from "./AltUsers.vue?vue&type=script&lang=js&"
export * from "./AltUsers.vue?vue&type=script&lang=js&"
import style0 from "./AltUsers.vue?vue&type=style&index=0&id=3097a313&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3097a313",
  null
  
)

export default component.exports